export const externalInfluencerExceptions = {
    notFound: 'EXCEPTION.EXTERNAL_INFLUENCER.NOT_FOUND',
};
